import { API } from "../../../../common/api/constants";

// ПОЛУЧИТЬ СПИСОК МЕСТ РАЗМЕЩЕНИЯ ДЕТЕЙ В НОЧНОЕ ВРЕМЯ
export const GET_NIGHT_PLACEMENT_LIST = `${API}/order/orders/{order_id}/kids_night_lists`; // GET

// ДОБАВИТЬ В СПИСОК НОВОЕ МЕСТО РАЗМЕЩЕНИЯ ДЕТЕЙ В НОЧНОЕ ВРЕМЯ
export const ADD_NIGHT_PLACEMENT_TO_LIST = `${API}/order/orders/{order_id}/kids_night_lists`; // POST

// ИЗМЕНИТЬ МЕСТО РАЗМЕЩЕНИЯ ДЕТЕЙ В НОЧНОЕ ВРЕМЯ
export const EDIT_NIGHT_PLACEMENT = `${API}/order/orders/{order_id}/kids_night_lists/{kids_night_list_id}`; // PUT

// УДАЛИТЬ МЕСТО РАЗМЕЩЕНИЯ ДЕТЕЙ В НОЧНОЕ ВРЕМЯ
export const DELETE_NIGHT_PLACEMENT = `${API}/order/orders/{order_id}/kids_night_lists/{kids_night_list_id}`; // DELETE
